"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ReviewReportHistoryModel", {
    enumerable: true,
    get: function() {
        return ReviewReportHistoryModel;
    }
});
const _zod = /*#__PURE__*/ _interop_require_default(require("zod"));
const _utilsisomorphic = require("@performyard/utils-isomorphic");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const ReviewReportHistoryBase = _zod.default.object({
    _id: _utilsisomorphic.transformObjectId,
    review_report: _utilsisomorphic.transformObjectId,
    company: _utilsisomorphic.transformObjectId,
    actor: _utilsisomorphic.transformObjectId
});
const ReviewReportHistoryEditsModel = _zod.default.object({
    authors: _zod.default.array(_utilsisomorphic.transformObjectId.nullable()).optional(),
    signers: _zod.default.array(_utilsisomorphic.transformObjectId.nullable()).optional(),
    visible: _zod.default.boolean().optional(),
    redacted: _zod.default.boolean().optional(),
    authors_due_date: _utilsisomorphic.transformDate.optional(),
    signers_due_date: _utilsisomorphic.transformDate.optional()
});
const SubmitHistory = ReviewReportHistoryBase.extend({
    action: _zod.default.literal("submit"),
    comment: _zod.default.string().optional()
});
const SaveHistory = ReviewReportHistoryBase.extend({
    action: _zod.default.literal("save")
});
const EditHistory = ReviewReportHistoryBase.extend({
    action: _zod.default.literal("edit"),
    edits: ReviewReportHistoryEditsModel
});
const SignOffHistory = ReviewReportHistoryBase.extend({
    action: _zod.default.literal("sign-off"),
    comment: _zod.default.string().optional()
});
const SendBackHistory = ReviewReportHistoryBase.extend({
    action: _zod.default.literal("send-back"),
    comment: _zod.default.string().optional(),
    old_author: _utilsisomorphic.transformObjectId.nullable(),
    new_author: _utilsisomorphic.transformObjectId.nullable(),
    old_author_turn: _zod.default.number(),
    new_author_turn: _zod.default.number(),
    old_signer: _utilsisomorphic.transformObjectId.nullable(),
    new_signer: _utilsisomorphic.transformObjectId.nullable(),
    old_signer_turn: _zod.default.number(),
    new_signer_turn: _zod.default.number()
});
const SendInviteHistory = ReviewReportHistoryBase.extend({
    action: _zod.default.literal("send-invite")
});
const ReopenHistory = ReviewReportHistoryBase.extend({
    action: _zod.default.literal("reopen")
});
const CloseHistory = ReviewReportHistoryBase.extend({
    action: _zod.default.literal("close")
});
const ReviewReportHistoryModel = _zod.default.discriminatedUnion("action", [
    SubmitHistory,
    SignOffHistory,
    SaveHistory,
    EditHistory,
    SendBackHistory,
    SendInviteHistory,
    ReopenHistory,
    CloseHistory
]);
